const apis: wx.Api[] = [
  'sendChatMessage',
  'onMenuShareAppMessage',
  'onMenuShareWechat',
  'onMenuShareTimeline',
  'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'playVoice',
  'pauseVoice',
  'stopVoice',
  'onVoicePlayEnd',
  'uploadVoice',
  'downloadVoice',
  'previewImage',
  'uploadImage',
  'downloadImage',
  'getLocalImgData',
  'getNetworkType',
  'onNetworkStatusChange',
  'openLocation',
  'getLocation',
  'startAutoLBS',
  'stopAutoLBS',
  'onLocationChange',
  'onHistoryBack',
  'hideOptionMenu',
  'showOptionMenu',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem',
  'openDefaultBrowser',
  'scanQRCode',
  'selectEnterpriseContact',
  'openEnterpriseChat',
  'selectExternalContact',
  'getCurExternalContact',
  'openUserProfile',
  'shareAppMessage',
  'shareWechatMessage',
  'startWifi',
  'stopWifi',
  'connectWifi',
  'getWifiList',
  'onGetWifiList',
  'onWifiConnected',
  'getConnectedWifi',
  'setClipboardData',
  'wwapp.getOpenData',
  'wwapp.initWwOpenData',
  'getCurExternalChat',
];

export default apis;
